import type { Data, Node, Parent, Root } from 'mdast';

import { streamingCaretClassName } from '~/ui/domain/chat/AssistantBubble';

// A caret rendered after the markdown would sit below the last paragraph, because every markdown
// block is a block element. This remark plugin puts it at the end of the deepest last node instead,
// so it follows the text that is streaming in.
type StreamingCaretNodeData = Data & {
    readonly hName: 'span';
    readonly hProperties: { readonly ariaHidden: true; readonly className: string };
};

interface StreamingCaretNode extends Node {
    readonly type: 'streamingCaret';
    readonly data: StreamingCaretNodeData;
}

declare module 'mdast' {
    interface PhrasingContentMap {
        streamingCaret: StreamingCaretNode;
    }
    interface RootContentMap {
        streamingCaret: StreamingCaretNode;
    }
}

const hasChildren = (node: Node | undefined): node is Parent => node !== undefined && 'children' in node;

export const remarkStreamingCaret =
    () =>
    (tree: Root): undefined => {
        let parent: Parent = tree;
        for (let last = parent.children.at(-1); hasChildren(last); last = parent.children.at(-1)) {
            parent = last;
        }
        parent.children.push({
            data: { hName: 'span', hProperties: { ariaHidden: true, className: streamingCaretClassName } },
            type: 'streamingCaret',
        });
    };
